<template>
  <v-container>
    <v-row
      class="main--text"
      align="center"
      justify="center">
      <v-col md="8">
        <v-card>
          <v-card-text>
            <v-card-title
            class="font-weight-bold">
            先生用 新規登録フォーム
            </v-card-title>
          </v-card-text>
          <v-card-text
            class="font-weight-bold red--text"
            v-show="errorMessage">
            {{ errorMessage }}
          </v-card-text>
          <v-card-text>
            <v-form
              ref="form"
              lazy-validation
            >
              <v-text-field
                v-model="email"
                name="username"
                label="メールアドレス"
                type="text"
                v-validate="'required|email'"
                data-vv-name="email"
                data-vv-as="メールアドレス"
                required
                :error-messages="errors.collect('email')"
              ></v-text-field>
              <v-text-field
                v-model="password"
                name="password"
                label="パスワード"
                type="password"
                v-validate="'required|min:6|alpha_num'"
                data-vv-name="password"
                data-vv-as="パスワード"
                required
                ref="password"
                :error-messages="errors.collect('password')"
                ></v-text-field>
              <v-text-field
                v-model="confirmPassword"
                label="パスワード(確認用)"
                type="password"
                v-validate="'required|confirmed:password'"
                data-vv-name="confirmPassword"
                data-vv-as="パスワード(確認用)"
                required
                :error-messages="errors.collect('confirmPassword')"
              ></v-text-field>
              <v-container
                fluid>
                <v-row justify="center">
                  <v-card-text>下記「ご利用規約」をお読みのうえ、「同意する」にチェックをしてください。</v-card-text><br>
                  <h2
                    style="cursor:pointer"
                    @click="terms=!terms">
                    <u v-if="!terms">Prosense利用規約</u>
                  </h2>
                <div v-if="terms">
                  <terms-of-teacher-service/>
                </div>

                <v-checkbox
                  v-if="terms"
                  label="ご利用規約に同意する"
                  v-model="termsChecked"
                  required></v-checkbox>
                </v-row>

              </v-container>
            </v-form>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="signUp()"
            >登録
            </v-btn>
          </v-card-text>
          <TeacherSignUpDialog
            :enable="dialog"
            :inProgress="inProgress"
            @reSend="sendEmail"
            @finish="toLogin"
          />
          <v-card-text>
            <v-btn
              color="primary"
              @click="$router.push('/parent/top')"
            >父兄の方はこちら
            </v-btn>
          </v-card-text>
        </v-card>
        <v-container>
        <v-btn
          color="primary"
          class="ma-2"
          @click="$router.push('/teacher/top')">
          戻る
        </v-btn>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog
      :value="checkTermsDialog"
      persistent
      width="350">
      <v-card>
        <v-container>
          ご利用規約への同意をお願いします。
          <v-row
            justify=center>
            <v-col
              cols=auto>

              <v-btn
                rounded
                outlined
                color="primary"
                @click="checkTermsDialog=false">
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="validationDialog"
      persistent
      width="350">
      <v-card>
        <v-container>
          未記入の箇所があります。
          <v-row
            justify=center>
            <v-col
              cols=auto>

              <v-btn
                rounded
                outlined
                color="primary"
                @click="validationDialog=false">
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { auth } from '@/auth/client/firebase'
import { firestore } from '@/repository/client/firestore.js'
import { AuthService } from '@/service/auth/auth'
import TeacherSignUpDialog from '@/components/organisms/teacher/TeacherSignUpDialog.vue'
import TermsOfTeacherService from '@/components/organisms/teacher/TermsOfTeacherService.vue'

export default {
  name: 'TeacherSignup',
  components: {
    'TeacherSignUpDialog': TeacherSignUpDialog,
    'TermsOfTeacherService': TermsOfTeacherService
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      dialog: false,
      errorMessage: "",
      inProgress: true,
      user: null,
      termsChecked: false,
      terms: false,
      checkTermsDialog: false,
      validationDialog: false
    }
  },
  methods: {
    async signUp() {
      const result = await this.$validator.validateAll()
      if (result) {
        if (this.termsChecked) {
          try {
            this.dialog = true
            this.user = await this.authService.createUser(this.email, this.password, process.env.VUE_APP_TEACHER_SIGNUPED_URL)
            this.inProgress = false
          } catch(e) {
            this.dialog = false
            this.errorMessage = e.message
          }
        } else {
          this.checkTermsDialog = true
        }
      } else {
        this.validationDialog = true
      }
    },
    async sendEmail() {
      this.inProgress = true
      await this.authService.deleteUser(this.email, this.password)
      try {
        this.user = await this.authService.resendVerifyMail(this.email, this.password, process.env.VUE_APP_TEACHER_SIGNUPED_URL)
        this.inProgress = false
      } catch (e) {
        this.dialog = false
        this.errorMessage = e.message
      }
    },
    toLogin() {
      // this.$store.commit("loginAsTeacher")
      this.$router.push('/teacher/top')
    },
  },
  created: function() {
    this.authService = new AuthService(auth, firestore)
  }
}
</script>

<style scoped>

.white-text {
  color:white;
}

</style>
